import React from 'react';
import { CFlex, CSpacing, CText, CTextColor, CTextSize, CTextWeight, FlexDirection } from '@/src';

interface Props {
  title: string;
  description?: string;
}

export const CTextListHeader = ({ title, description }: Props) => {
  return (
    <CFlex gap={CSpacing.Md} direction={FlexDirection.Column}>
      <CText as="h5" size={CTextSize.Md} weight={CTextWeight.Bold}>
        {title}
      </CText>
      <CText size={CTextSize.Sm} color={CTextColor.Info}>
        {description}
      </CText>
    </CFlex>
  );
};
